import { ControlsToggleExtraContent, LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

export const components: LayoutComponent[] = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/17/principle/cylinder-200-hz.svg`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
];

export const extraContent: ControlsToggleExtraContent = [
  {
    type: "text",
    options: {
      data: "Field pressure",
      formatter: "html",
      scrollbars: false,
      styles: {
        fontSize: "12px",
        fontWeight: 700,
        lineHeight: "18px",
      },
    },
  },
  {
    type: "text",
    options: {
      data: "ka = 0.73",
      formatter: "html",
      scrollbars: false,
      styles: {
        fontSize: "18px",
        fontWeight: 400,
        lineHeight: "14px",
      },
    },
  },
];
